import { MirrorSelect } from '@crasman/multiselect';

/**
 * Dropdown class.
 *
 * @class Dropdown
 */
class Dropdown {
  settings = {
    listElement: { size: 12, preventScrollOnFocus: false },
    mirrorNative: true,
    searchable: {
      searchable: true,
      selectionClears: true,
      enterSelects: true,
    },
  };

  /**
   * Inner HTML code for adding close button. Slightly ugly, but does the job
   * without needing to change things in the backend or bloating the dropdown component
   * to get the buttons.
   * @type {string}
   */
  closeButton = `<button class="btn btn--red close-dropdown" type="button">Hyväksy</button>`;

  /**
   * Inner HTML code for adding clear button. Slightly ugly, but does the job
   * without needing to change things in the backend or bloating the dropdown component
   * to get the buttons.
   * @type {string}
   */
  clearButton = `<button class="btn btn--secondary clear-dropdown-selections" type="button">Tyhjennä</button>`;

  constructor() {
    const dropdownElements = document.querySelectorAll('.js-select, .js-multiselect');
    dropdownElements.forEach(select => {
      // Instantiate MirrorSelect + add reference to it to the container element
      // for use in event listeners.
      const mirrorSelect = new MirrorSelect(select, this.settings);
      mirrorSelect.containerElement.mirrorSelectObject = mirrorSelect;

      // Add clear and close buttons as a separate li element within the options list of
      // the dropdown. Downside is that this is not always visible. Upside is that it
      // doesn't break styling as drastically as a separate div outside the list would.
      const multiselectList = select.parentElement.querySelector('.multiselect-list');

      // create new container to ul list
      const container = document.createElement('div');
      container.classList.add('dropdown--container__list-buttons');
      const multiselectListParent = multiselectList.parentElement;
      multiselectListParent.removeChild(multiselectList);

      // move multiselectList to containe
      container.appendChild(multiselectList);
      // append container to multiselect

      multiselectListParent.appendChild(container);
      if (multiselectList) {
        const clearCloseListItem = document.createElement('div');
        clearCloseListItem.classList.add('dropdown--clear-close-buttons');
        let buttonsInnerHTML = '';

        if (select.classList.contains('js-multiselect')) {
          buttonsInnerHTML += this.clearButton;
          buttonsInnerHTML += this.closeButton;

          clearCloseListItem.innerHTML = buttonsInnerHTML;
          //multiselectList.appendChild(clearCloseListItem);

          container.appendChild(clearCloseListItem);
          // append container to multiselect

          multiselectListParent.appendChild(container);
        }

        // Add event listeners to clear and close buttons.
        const clearSelectionsButton = clearCloseListItem.querySelector('.clear-dropdown-selections');
        const closeButton = clearCloseListItem.querySelector('.close-dropdown');
        if (clearSelectionsButton) {
          clearSelectionsButton.addEventListener('click', event => this.#onClearButtonClick(event));
        }
        if (closeButton) {
          closeButton.addEventListener('click', event => {
            this.#onCloseButtonClick(event);
          });
        }

        multiselectList.addEventListener('keydown', event => this.#onCloseButtonClick(event));

        select.addEventListener('change', event => {
          //selected options text
          const selectedOptionsText = [];
          const selectedOptions = select.querySelectorAll('option:checked');
          selectedOptions.forEach(option => {
            selectedOptionsText.push(option.innerText);
          });
          //get input type search
          const input = multiselectListParent.querySelector('input[type="search"]');
          //put selected options text to input placeholder
          if (input && selectedOptionsText.length > 0) {
            // clear valitse text
            //selectedOptionsText.splice(0, 1);
            input.placeholder = selectedOptionsText.join(', ');
          } else {
            input.placeholder = 'Valitse';
          }
        });
      }
    });
  }

  /**
   * Clear button's event listener method.
   * @param {Event} event - event
   */
  #onClearButtonClick(event) {
    const container = event.target.closest('.multiselect-container');
    if (!container) return;

    event.target.blur();
    const options = container.querySelectorAll('option:checked');
    options.forEach(option => {
      option.removeAttribute('selected');
      option.selected = false;
    });
    container.mirrorSelectObject.closeOptionsList();
    container.querySelector('select')?.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /**
   * Close button's event listener method.
   * @param {Event} event - event
   */
  #onCloseButtonClick(event) {
    const container = event.target.closest('.multiselect-container');
    if (!container) return;

    event.target.blur();
    container.mirrorSelectObject.closeOptionsList();
  }
}

export { Dropdown };
